import { render, staticRenderFns } from "./addStaticPage.vue?vue&type=template&id=4a1e7169&scoped=true&"
import script from "./addStaticPage.vue?vue&type=script&lang=js&"
export * from "./addStaticPage.vue?vue&type=script&lang=js&"
import style0 from "./addStaticPage.vue?vue&type=style&index=0&id=4a1e7169&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1e7169",
  null
  
)

export default component.exports